/* @flow */
import type { Record } from 'immutable';

import { ADD_ALERT, DELETE_ALERT } from './action-types.js';
import type { AlertObject } from './constants.js';

export const alert = (payload: AlertObject): Object => ({
  type: ADD_ALERT,
  payload,
});

// TODO: Create Alert with action item (such as links)
export const success = (text: string) => alert({ type: 'success', text });

export const warn = (text: string) => alert({ type: 'warning', text });

export const info = (text: string) => alert({ type: 'info', text });

export const error = (text: string) => alert({ type: 'error', text });

export const deleteAlert = (payload: Record<AlertObject & { id: string }>): Object => ({
  type: DELETE_ALERT,
  payload,
});



// WEBPACK FOOTER //
// ./src/app/modules/alerts/actions.js